import { useEffect, useState } from 'react';
import axios from 'axios';
import Main from '../../../component/Main';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid';
import ExcelDownload from '../../../component/common/button/ExcelDownload';
import BdExceptTransLayer from './BdExceptTrans_layer';
import useModalStore from '../../../zustand/store/useModalStore';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle';
import * as Icons from '../../../images/icons/icons_component';

const BdExceptTrans = () => {

    const today = new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0];

    const [searchParams, setSearchParams] = useState({
        searchGrdc: '',
        searchLoca: '',
        searchEmog: '',
        searchFromdate: today,
        searchTodate: today,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prev => ({ ...prev, [name]: value }));
    };

    const dataHead = ['의료기관', '전송마감 예외기간', '전송허용 내원일자', '사유', '담당자', '처리일자'];
    const dataColumn = ['EMOGDESC', 'EMMGEXTM', 'EMMGOFTM', 'EMMGMEMO', 'EMMGUSER', 'EMMGDATE'];
    const excelFileName = '전송기준 예외관리';

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: '/ptmiapi/system/nedis/codeweb/bdexceptranslist.do',
        apiCntCall: '',
        excelFileName: excelFileName,
        excelHead: [],
        colWidth: ['20%', '22%', '18%', '18%', '10%', '12%'],
        wrapTF: true,
    };

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false,
    });

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0,
    });

    // 등록/수정 후 목록 재조회
    const [reSearch, setReSearch] = useState(false);

    const [selectRow, setSelectRow] = useState();
    const selectCellParams = ['EMMGEMCD'];

    const [isModalOpen, setIsModalOpen] = useState({
        modalState: false,
        smode: 'I',
        row: null,
    });

    const showNotiModal = useModalStore(state => state.showNotiModal);

    // Dynamic Style Hook
    const { primaryBackColor, fontColor } = useDynamicStyle();

    const fetchData = async () => {
        try {
            setState(prev => ({ ...prev, isLoading: true }));

            const { data } = await axios.get(propsInfo.apiCall, { params: searchParams });

            setState(prev => ({ ...prev, dataList: data, isSearched: true, isLoading: false }));
            setPageInfo(prev => ({ ...prev, totalItems: data.length }));
        } catch (error) {
            console.error('전송기준 예외관리 데이터 로딩 중 오류 발생:', error);
            setState(prev => ({ ...prev, isLoading: false }));
        }
    };

    useEffect(() => {
        if (reSearch) {
            fetchData();
            setSelectRow(undefined);
            setReSearch(false);
        }
    }, [reSearch]);

    const search = () => {
        if (!searchParams.searchFromdate || !searchParams.searchTodate) {
            showNotiModal('검색기간을 선택해주세요.');
            return;
        }
        if (searchParams.searchTodate < searchParams.searchFromdate) {
            showNotiModal('검색 종료일자가 검색 시작일자보다 과거일 수 없습니다.');
            return;
        }
        setSelectRow(undefined);
        fetchData();
    };

    // 그리드 행 클릭 시 수정 레이어 표출
    const handleOnClick = (dataList, index, selectCellParams, key) => {
        setSelectRow(key);
        setIsModalOpen({ modalState: true, smode: 'U', row: dataList[index] });
    };

    const modalOpen = () => {
        setSelectRow(undefined);
        setIsModalOpen({ modalState: true, smode: 'I', row: null });
    };

    const modalClose = () => {
        setIsModalOpen(prev => ({ ...prev, modalState: false }));
    };

    return (
        <Main>
            <BdExceptTransLayer
                isModalOpen={isModalOpen}
                modalClose={modalClose}
                setReSearch={setReSearch}
            />
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width='9%' />
                        <col width='24%' />
                        <col width='9%' />
                        <col width='19%' />
                        <col width='9%' />
                        <col width='20%' />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>전송마감 예외기간</th>
                            <td colSpan={5}>
                                <input
                                    type='date'
                                    name='searchFromdate'
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type='date'
                                    name='searchTodate'
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className='search_btn_wrapper'>
                <span className='total_items'>전체&nbsp;<strong className={fontColor}>{pageInfo.totalItems}</strong>건</span>
                <div className='btn_container'>
                    <button type='button' onClick={search} disabled={state.isLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Icons.Search16w />검색</button>
                    <button type='button' onClick={modalOpen} className='search_btn bg_st_primary'><Icons.AddCircle16w />신규등록</button>
                    <ExcelDownload
                        excelHead={dataHead}
                        excelData={state.dataList}
                        searched={state.isSearched}
                        dataCode={dataColumn}
                        excelFileName={excelFileName}
                    />
                </div>
            </div>

            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                selectCellParams={selectCellParams}
                handleOnClick={handleOnClick}
                selectRow={selectRow}
            />

            <div className='mt-2'>
                <p>- 목록의 행을 클릭하면 해당 전송기준 예외정보를 수정하거나 삭제할 수 있습니다.</p>
                <p>- 전송마감 예외기간이 이미 도래한 자료는 수정/삭제할 수 없습니다.</p>
            </div>
        </Main>
    );
};

export default BdExceptTrans;
